export default "__VITE_ASSET__2iBphCTJ__"